import { AssistChip, Skeleton, Stack, Text } from '@sixui/ui';

import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';

export const AppUserListItemSkeleton: React.FC = () => (
  <Table.Row>
    <Stack as={Table.Body} horizontal gap={3}>
      <Skeleton variant="circular">
        <UserAvatar />
      </Skeleton>
      <Stack gap={1}>
        <Text
          as={Skeleton}
          variant="title"
          size="sm"
          length={{ min: 8, max: 24 }}
        />
        <Text
          as={Skeleton}
          variant="body"
          size="sm"
          length={{ min: 8, max: 32 }}
        />
      </Stack>
    </Stack>

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }}>
        <AssistChip />
      </Skeleton>
    </Table.Body>

    <Stack as={Table.Body} justify="end">
      <Skeleton length={8} />
    </Stack>
  </Table.Row>
);
